import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Route, RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import SophisticatedFtueTooltip from '@wix/da-shared-react/pkg/Popover/Preset/SophisticatedFtueTooltip';
import { FirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/constants';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import { Nav } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import classnames from 'classnames';
import { Route as RouteDefinition } from '../../../../types/route';

import s from './SubNavBarMobile.scss';

export interface SubNavBarProps {
  routes: RouteDefinition[];
  isSticky: boolean;
  biClickProfileNavBar: (linkName: string) => void;
}

class SubNavBarMobileInner extends React.PureComponent<
  SubNavBarProps & WithTranslation & RouteComponentProps<any>
> {
  navRef: React.RefObject<any> = React.createRef();
  navListRef: React.RefObject<any> = React.createRef();

  componentDidMount() {
    this.scrollToActive();
  }

  render() {
    const { isSticky, routes, biClickProfileNavBar, t } = this.props;
    return (
      <Nav
        className={classnames(s['navbar'], isSticky && s['sticky'])}
        ref={this.navRef}
      >
        <VisuallyHidden>
          <Heading>{t('navigation.subnavigation.heading')}</Heading>
        </VisuallyHidden>
        <div className={s['nav-list']} ref={this.navListRef}>
          <Route
            key="nav-user"
            path="/:username"
            render={({ match }) =>
              routes.map(route => (
                <NavLink
                  key={route.key}
                  to={(route.path || '')
                    .replace(/:username/, match.params.username)
                    .replace(/\/:[a-z0-9_()\\+]+\?/gi, '')}
                  exact={route.exact}
                  className={s['nav-item']}
                  activeClassName={s['active']}
                  onClick={() => biClickProfileNavBar(route.key)}
                >
                  {route.key === 'subscriptions' ? (
                    <Flag
                      condition="ms_ftue_subscriptions_tab"
                      render={() => (
                        <SophisticatedFtueTooltip
                          flag={FirstTimeFlag.IsSubscriptionsTabNotViewed}
                          size="medium"
                          placement="bottom"
                          hasCloseButton
                          usePortal
                          contentClassName={s['nav-item-tooltip']}
                          aria-label={t(
                            'navigation.route.subscriptions.ftue.a11y.label'
                          )}
                          postfix={(
                            <span className={s['nav-item-tooltip-content']}>
                              {t('navigation.route.subscriptions.ftue')}
                            </span>
                          )}
                        >
                          {t(`navigation.route.var.${route.key}`)}
                        </SophisticatedFtueTooltip>
                      )}
                      fallbackRender={() => t(`navigation.route.var.${route.key}`)}
                    />
                  ) : t(`navigation.route.var.${route.key}`)
                  }
                  {route.isBeta && <span className={s['beta']}>beta</span>}
                </NavLink>
              ))
            }
          />
        </div>
      </Nav>
    );
  }

  scrollToActive = () => {
    const activeRouteRef = Array.from(this.navListRef.current!.children).find(
      routeItem => (routeItem as HTMLElement).classList.contains(s['active'])
    ) as HTMLElement;

    if (!activeRouteRef) {
      return;
    }

    const navRef = this.navRef.current!;

    // calculate new scrollLeft value so the activeRoute will be in the middle
    const newScrollLeft =
      activeRouteRef.offsetLeft - navRef.getBoundingClientRect().width / 2;

    navRef.scrollLeft = newScrollLeft;
  };
}

export default withRouter(withTranslation()(SubNavBarMobileInner));
